import { render, staticRenderFns } from "./p22.vue?vue&type=template&id=34d5ed6a&scoped=true&"
import script from "./p22.vue?vue&type=script&lang=js&"
export * from "./p22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d5ed6a",
  null
  
)

export default component.exports